module.exports = __webpack_public_path__ + "static/img/item-3-2.1ea52ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-3-2.png
// module id = 56VQ
// module chunks = 2